import { connect, MapDispatchToProps } from 'react-redux';
import { likeComment, unlikeComment } from '../../redux/actionCreators';
import { Props } from './LikeButton';

type DispatchProps = Pick<Props, 'onLike' | 'onUnlike'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onLike: likeComment,
  onUnlike: unlikeComment,
};

export default connect(null, mapDispatchToProps);
